import React from 'react';
import { useTooltipInPortal } from '@vx/tooltip';

import { useChartTooltipContext } from '../../../store/ChartTooltipContext';
import { TooltipWrapper } from './tooltipWithPortal.styles';
import './tooltipWithPortal.css';

export const TooltipWithPortal = ({ children }) => {
  const tooltip = useChartTooltipContext();

  const { TooltipInPortal } = useTooltipInPortal({
    // when tooltip containers are scrolled, this will correctly update the Tooltip position
    scroll: true,
  });

  return (
    <TooltipInPortal left={tooltip.left} top={tooltip.top} key={Math.random()} className="tooltip">
      <TooltipWrapper>{children}</TooltipWrapper>
    </TooltipInPortal>
  );
};
